import React, { useState } from 'react';
import { Container, Grid, Typography } from '@material-ui/core';
import Button, { ButtonProps } from '@material-ui/core/Button';
import { useTranslation } from 'react-i18next';
import { useStyles } from './Styles';
import { urlJoin } from 'url-join-ts';
import settings from '../../config/settings';

interface Props {
    handleButtonClick?: Function,
    headerText: any,
    bodyText: any | string,
    buttonText?: any,
    buttonProps?: ButtonProps,
    clientAppText?: any,
    detailedErrorDescription?: any,
    expandDetailedErrorDescription?: boolean,
    dip_app_type?: string,
    endAdornment?: React.ReactNode,
    iconURL?: string
}

const Information: React.FC<Props> = ({ handleButtonClick, headerText, bodyText, buttonText, clientAppText, detailedErrorDescription, expandDetailedErrorDescription, dip_app_type, endAdornment, iconURL, buttonProps = {} }) => {

    const [showDetailedError, setShowDetailedError] = useState(expandDetailedErrorDescription && detailedErrorDescription);
    const { t } = useTranslation();
    const classes = useStyles();

    return (
        <Container data-testid='information'>
            <Grid container className={classes.contentContainer}>
                <Grid item xs={12}>
                    <Typography className={`${classes.mainTitle}`} data-testid='header-text'>
                        {headerText}
                    </Typography>
                </Grid>
                {iconURL && (
                    <Grid item xs={12} className={classes.iconContainer}>
                        <img src={iconURL} alt="" className={classes.iconStyleBig} />
                    </Grid>
                )}
                <Grid item xs={12} className={classes.textContainer} data-testid='body-text'>
                    {bodyText}
                </Grid>
                {detailedErrorDescription && detailedErrorDescription.length > 0 &&
                    <Grid item xs={12} className={classes.detailedErrorContainer}>
                        <React.Fragment>
                            <div className={classes.showHide} onClick={() => { setShowDetailedError(!showDetailedError) }}>
                                {showDetailedError ?
                                    <img src={urlJoin(settings.staticFiles.endpoint, '/images/system/ChevronDownRed.svg')} className={classes.iconStyleRotate} alt='' />
                                    :
                                    <img src={urlJoin(settings.staticFiles.endpoint, '/images/system/ChevronDownRed.svg')} className={classes.iconStyle} alt='' />
                                }
                                <span>{t(`custom_error_page.${!showDetailedError ? 'show_detailed_info' : 'hide_detailed_info'}`)}</span>
                            </div>
                        </React.Fragment>
                        {showDetailedError ?
                            <div className={classes.wordBreak}>
                                {detailedErrorDescription}
                            </div>
                            : null}
                    </Grid>
                }
                {dip_app_type !== 'client_app' && buttonText && (
                    <Grid container className={classes.buttonContainer}>
                        <Grid item xs={12}>
                            <Button
                                type='submit'
                                data-testid='submit-button'
                                variant='contained'
                                color='primary'
                                className={classes.button}
                                onClick={() => handleButtonClick?.()}
                                id='dip_information_submit'
                                {...buttonProps}
                            >
                                {buttonText}
                            </Button>
                        </Grid>
                    </Grid>
                )}
                {dip_app_type === 'client_app' && (
                    <Grid container className={classes.textContainer}>
                        <Grid item xs={12}>
                            {clientAppText}
                        </Grid>
                    </Grid>
                )}
                {endAdornment}
            </Grid>
        </Container>
    );
}

export default Information;
